<p-card class="mt-3">
        <app-table-component class="cars-table" [data]="cars" [columns]="tableColumns" [totalRecords]="totalRecords" [rows]="rows" [first]="first" (pageChange)="pageChange.emit($event)" [tableName]="''"
        (searchChange)="searchChange.emit()" [searchControl]="searchControl"
        [customFilters]="[rentalTypeFilter, modelsFilter, needsRebalancingFilter]"
        [showColumnSelector]="false" [showHeaderBorder]="false"
        [showTable]="activeView() === 'list'"
        searchPlaceholder="Search by plate, VIN, maker, model..."
        [rowCommand]="redirectToCarDetails"
        [rowLink]="carRowLink"
        [headerActions]="viewToggle">
        @if (activeView() === 'list') {
        <app-cars-list-mobile class="mobile-list-view" [cars]="cars" [totalRecords]="totalRecords" [rows]="rows" [first]="first"
            (pageChange)="pageChange.emit($event)" (carClick)="redirectToCarDetails($event)">
        </app-cars-list-mobile>
        }
        @if (activeView() === 'cards') {
        <app-cars-list-cards [cars]="cars" [totalRecords]="totalRecords" [rows]="rows" [first]="first" (pageChange)="pageChange.emit($event)"></app-cars-list-cards>
        }
        @if (activeView() === 'map') {
        <app-cars-list-map></app-cars-list-map>
        }
    </app-table-component>

    <ng-template #viewToggle>
        <div class="view-toggle">
            <button class="view-btn" [class.view-btn--active]="activeView() === 'list'" (click)="setView('list')">
                <img src="assets/icons/cars-view-list.svg" alt="carsList" />
            </button>
            <button class="view-btn" [class.view-btn--active]="activeView() === 'cards'" (click)="setView('cards')">
                <img src="assets/icons/cars-view-cards.svg" alt="carsCards" />
            </button>
            <button class="view-btn" [class.view-btn--active]="activeView() === 'map'" (click)="setView('map')">
                <img src="assets/icons/cars-view-maps.svg" alt="carsMap" />
            </button>
        </div>
    </ng-template>
</p-card>
@defer (when updateCarDialog; prefetch on idle) {
<app-update-car-form (updatedCar)="onCarUpdated()" [selectedCar]="selectedCar" [(visibility)]="updateCarDialog" />
}

@defer (when updateCarStatusDialog; prefetch on idle) {
<app-update-car-status-form (updatedCarStatus)="onCarStatusUpdated()" [selectedCar]="selectedCar" [(visibility)]="updateCarStatusDialog" />
}

@defer (when deleteCarDialog; prefetch on idle) {
<app-delete-car-form (deletedCar)="onCarDeleted()" [selectedCar]="selectedCar" [(visibility)]="deleteCarDialog" />
}

@defer (when cancelReservationDialog; prefetch on idle) {
<app-cancel-reservation-form (canceledReservation)="onCarCanceled()" [selectedCar]="selectedCar" [(visibility)]="cancelReservationDialog" />
}